/**
 * One-Click Cache Clear Utility Function
 * Unregisters Service Workers, clears Cache Storage API, and hard-reloads the PWA.
 */
export async function clearAppCache(): Promise<void> {
  try {
    // 1. Unregister active Service Workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
      }
    }

    // 2. Delete all Cache Storage entries
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    // 3. Clear Session Storage & non-critical LocalStorage entries if needed
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.clear();
    }

    console.log('[CacheUtility] Successfully cleared Service Workers and Cache Storage.');
  } catch (error) {
    console.error('[CacheUtility] Error clearing cache:', error);
  } finally {
    // 4. Perform hard reload
    window.location.reload();
  }
}
